export default __webpack_public_path__ + "static/media/capital_section_image_tablet.9ed71732.jpg";